import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllBanners } from "store/Content/actions"
import uniqBy from "lodash/uniqBy"
import {sitename} from "../../../../constants/constants";

const Content = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllBanners())
  }, [])
  const Banners = useSelector(state => state.content.Index ?? [])
  // const uniqueBanners = uniqBy(Banners, "page_name")
  const uniqueBanners = Banners

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Banners" />
        </Container>
        <Table data={Banners} uniqueBanners={uniqueBanners} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Content)
